import tw from "tailwind-styled-components";

export const CsvLinkBtn = tw.div`
bg-gray-700
 hover:bg-gray-500 
 text-white
  font-bold 
  py-1 
  px-3 
  rounded 

  mr-2

`;

export const PrintAllBtn = tw.div`
bg-cyan-700
 hover:bg-cyan-500 
 text-white
  font-bold 
  py-1 
  px-3 
  rounded 

  mr-2
  ml-2

`;

export const TableHeraderh2 = tw.h2`

text-2xl
ml-4
pb-3
`;
